<template>
  <div class="teacher-dashboard" ref="dashboardRef">
    <div class="bg">
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <!-- 顶部标题装饰 -->
        <div class="header-wrapper">
          <dv-decoration-10 class="dv-dec-10-top" />
          <dv-decoration-8 class="dv-dec-8-left" :color="decorationColor" />
          <div class="title-container">
            <div class="title">
              <span class="title-text">睿学云舵数据可视化分析平台</span>
            </div>
            <dv-decoration-6
              class="dv-dec-6"
              :reverse="true"
              :color="['#50e3c2', '#67a1e5']"
            />
          </div>
          <dv-decoration-8 class="dv-dec-8-right" :reverse="true" :color="decorationColor" />
          <dv-decoration-10 class="dv-dec-10-bottom" />
        </div>

        <!-- 次级信息栏 -->
        <div class="d-flex jc-between px-2 info-wrapper">
          <div class="d-flex aside-width">
            <div class="react-left ml-4 react-l-s">
              <span class="react-left"></span>
              <span class="text">教师端</span>
            </div>
            <div class="react-left ml-3">
              <router-link to="/student" class="nav-btn">
                <span class="text">切换到学生端</span>
              </router-link>
            </div>
          </div>
          <div class="d-flex aside-width">
            <div class="react-right bg-color-blue mr-3">
              <span class="text fw-b">{{ teacherName }}</span>
            </div>
            <div class="react-right mr-4 react-l-s">
              <span class="react-after"></span>
              <span class="text">{{ dateYear }} {{ dateWeek }} {{ dateDay }}</span>
            </div>
          </div>
        </div>

        <!-- 主要内容区 -->
        <div class="body-box">
          <div class="content-box">
            <!-- 左侧资源分析 -->
            <div>
              <dv-border-box-12>
                <TeacherResourceAnalysis />
              </dv-border-box-12>
            </div>
            <!-- 中间教学评价 -->
            <div>
              <dv-border-box-12>
                <TeacherEvaluation />
              </dv-border-box-12>
            </div>
            <!-- 右侧学生分析 -->
            <div>
              <dv-border-box-13>
                <TeacherStudentAnalysis />
              </dv-border-box-13>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TeacherResourceAnalysis from '@/components/teacher/ResourceAnalysis.vue'
import TeacherEvaluation from '@/components/teacher/TeacherEvaluation.vue'
import TeacherStudentAnalysis from '@/components/teacher/StudentAnalysis.vue'
import { formatTime } from '@/utils/index.js'

export default {
  name: 'TeacherDashboard',
  data() {
    return {
      loading: true,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      teacherName: '王老师',
      weekday: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      decorationColor: ['#568aea', '#000000'],
      timing: null
    }
  },
  components: {
    TeacherResourceAnalysis,
    TeacherEvaluation,
    TeacherStudentAnalysis
  },
  mounted() {
    this.timeFn()
    this.cancelLoading()
  },
  beforeDestroy() {
    clearInterval(this.timing)
  },
  methods: {
    timeFn() {
      this.timing = setInterval(() => {
        this.dateDay = formatTime(new Date(), 'HH:mm:ss')
        this.dateYear = formatTime(new Date(), 'yyyy-MM-dd')
        this.dateWeek = this.weekday[new Date().getDay()]
      }, 1000)
    },
    cancelLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
.teacher-dashboard {
  width: 100%;
  height: 100vh;
  background: url('~@/assets/pageBg.png') no-repeat center center;
  background-size: cover;
  color: #fff;

  .bg {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    padding: 16px;
  }

  .host-body {
    .header-wrapper {
      position: relative;
      width: 100%;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;

      .dv-dec-10-top,
      .dv-dec-10-bottom {
        position: absolute;
        width: 100%;
        height: 5px;
        left: 0;
      }

      .dv-dec-10-top {
        top: 0;
      }

      .dv-dec-10-bottom {
        bottom: 0;
        transform: rotateX(180deg);
      }

      .dv-dec-8-left,
      .dv-dec-8-right {
        position: absolute;
        width: 250px;
        height: 50px;
        top: 50%;
        transform: translateY(-50%);
      }

      .dv-dec-8-left {
        left: 20px;
      }

      .dv-dec-8-right {
        right: 20px;
      }

      .title-container {
        position: relative;
        padding: 15px 0;
        
        .title {
          width: 800px;
          text-align: center;
          background-color: rgba(6, 30, 93, 0.5);
          border-radius: 70px;
          padding: 15px 40px;
          margin: 0 auto;
          
          .title-text {
            font-size: 42px;
            font-weight: bold;
            background: linear-gradient(to bottom, #fff, #4db6e5);
            -webkit-background-clip: text;
            color: transparent;
            white-space: nowrap;
          }
        }

        .dv-dec-6 {
          position: absolute;
          width: 100%;
          height: 8px;
          bottom: -5px;
          left: 0;
        }
      }
    }

    .info-wrapper {
      margin-top: 40px;
      
      .react-left {
        background-color: rgba(6, 30, 93, 0.5);
        border-radius: 5px;
        padding: 10px 20px;
        
        .text {
          color: #fff;
          font-size: 18px;
        }
      }
      
      .react-right {
        background-color: rgba(6, 30, 93, 0.5);
        border-radius: 5px;
        padding: 10px 20px;
        
        .text {
          color: #fff;
          font-size: 18px;
        }
      }
    }

    .body-box {
      margin-top: 20px;
      
      .content-box {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 20px;
        padding: 16px;
        
        & > div {
          height: calc(100vh - 300px);
          background-color: rgba(6, 30, 93, 0.5);
          border-radius: 10px;
          overflow: hidden;
        }
      }
    }
  }
}
</style> 